<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <!-- Header with back button -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px;">
          <div>
            <h1 style="margin-bottom: 8px;">Job #{{ jobId }} - Execution Logs</h1>
            @if (job) {
<p class="text-muted">Modernization Readiness Calculation Job Details</p>
}
          </div>
          <button type="button" class="btn btn-primary no-arrow" (click)="goBack()">
            Back to Job History
          </button>
        </div>

        <!-- Error message -->
        @if (error) {
<div class="alert alert-danger">
          <mat-icon>error</mat-icon> {{ error }}
        </div>
}

        @if (pageLoading) {
      <app-job-logs-skeleton></app-job-logs-skeleton>
      }

        <!-- Loading spinner -->
        <!-- <div *ngIf="loading && !job" style="text-align: center; padding: 40px;">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Loading job details...</p>
        </div> -->

        <!-- Job Summary -->
        @if (!pageLoading && job) {
<div class="card" style="margin-bottom: 20px;">
          <div class="card-header">
            <h5>Job Summary</h5>
          </div>
          <div class="card-body">
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 15px;">
              <div>
                <strong>Status:</strong>
                <span [class]="'badge ' + getStatusBadgeClass(job.status)" style="margin-left: 10px;">
                  {{ getStatusText(job.status) }}
                </span>
              </div>
              <div>
                <strong>Started:</strong> {{ formatDate(job.startedAt) }}
              </div>
              <div>
                <strong>Completed:</strong> {{ formatDate(job.completedAt) }}
              </div>
              <div>
                <strong>Duration:</strong> {{ formatDuration(job) }}
              </div>
              <div>
                <strong>Total Applications:</strong> {{ job.totalApplications }}
              </div>
              <div>
                <strong>Success:</strong> <span class="badge badge-success">{{ job.successCount }}</span>
              </div>
              <div>
                <strong>Failed:</strong> <span class="badge badge-danger">{{ job.failedCount }}</span>
              </div>
              <div>
                <strong>Skipped:</strong> <span class="badge badge-warning">{{ job.skippedCount }}</span>
              </div>
              @if (job.triggeredByUserName) {
<div>
                <strong>Triggered By:</strong> {{ job.triggeredByUserName }}
              </div>
}
            </div>
          </div>
        </div>
}

        <!-- Per-Application Logs -->
        @if (!pageLoading) {
<div class="card">
          <div class="card-header">
            <h5>Per-Application Logs</h5>
          </div>
          <div class="card-body">
            @if (!loading && jobLogs.length === 0) {
<div class="alert alert-info">
              <mat-icon>info</mat-icon> No logs available for this job.
            </div>
}

            <div class="table-responsive">
              @if (loading) {
<app-job-logs-table-skeleton></app-job-logs-table-skeleton>
}
              
              @if (!loading) {
<table class="table table-sm table-striped table-hover">
                <thead>
                  <tr>
                    <th>Application</th>
                    <th>Result</th>
                    <th>Outcome</th>
                    <th>Score</th>
                    <th>Recommendation</th>
                    <th>Processing Time</th>
                    <th>Error/Skip Reason</th>
                    <th>AI Response</th>
                  </tr>
                  <tr class="filter-row">
                    <th>
                      <input 
                        type="text" 
                        class="form-control form-control-sm" 
                        [(ngModel)]="filterApplicationName"
                        (input)="onFilterTextChange()"
                        (keyup.enter)="applyFilters()"
                        placeholder="Filter...">
                    </th>
                    <th>
                      <select 
                        class="form-control form-control-sm" 
                        [(ngModel)]="filterResult"
                        (change)="applyFilters()">
                        <option value="">All</option>
                        <option value="success">Success</option>
                        <option value="failed">Failed</option>
                        <option value="skipped">Skipped</option>
                      </select>
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>
                      @if (hasActiveFilters()) {
<button
                       
                        type="button"
                        class="btn btn-sm btn-danger no-arrow"
                        (click)="clearFilters()"
                        title="Clear all filters">
                        <mat-icon style="font-size: 16px; height: 16px; width: 16px;">clear</mat-icon>
                      </button>
}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (log of jobLogs; track log) {
<tr>
                    <td>
                      <strong>{{ log.applicationName || log.businessApplicationSysId }}</strong>
                    </td>
                    <td>
                      @if (log.success) {
<span class="badge badge-success">
                        <mat-icon style="font-size: 14px; height: 14px; width: 14px;">check_circle</mat-icon>
                        Success
                      </span>
}
                      @if (!log.success && !log.skipped) {
<span class="badge badge-danger">
                        <mat-icon style="font-size: 14px; height: 14px; width: 14px;">error</mat-icon>
                        Failed
                      </span>
}
                      @if (log.skipped) {
<span class="badge badge-warning">
                        <mat-icon style="font-size: 14px; height: 14px; width: 14px;">skip_next</mat-icon>
                        Skipped
                      </span>
}
                    </td>
                    <td>
                      @if (getOutcomeFromJson(log)) {
<span [class]="'badge ' + getOutcomeBadgeClass(getOutcomeFromJson(log))">
                          {{ getOutcomeFromJson(log) }}
                        </span>
}
                      @if (!getOutcomeFromJson(log)) {
<span class="text-muted">-</span>
}
                    </td>
                    <td>
                      @if (log.readinessScore !== null && log.readinessScore !== undefined) {
<span [class]="'badge ' + getScoreBadgeClass(log.readinessScore)">
                          {{ log.readinessScore }}
                        </span>
}
                      @if (log.readinessScore === null || log.readinessScore === undefined) {
<span class="text-muted">-</span>
}
                    </td>
                    <td>
                      @if (log.recommendedAction) {
<span [class]="'badge ' + getRecommendationBadgeClass(log.recommendedAction)">
                          {{ log.recommendedAction }}
                        </span>
}
                      @if (!log.recommendedAction) {
<span class="text-muted">-</span>
}
                    </td>
                    <td>{{ log.processingTimeMs ? log.processingTimeMs + 'ms' : '-' }}</td>
                    <td>
                      @if (log.errorMessage) {
<small class="text-danger">
                        <strong>Error:</strong> {{ log.errorMessage }}
                      </small>
}
                      @if (log.skipReason && !log.errorMessage) {
<small class="text-warning">
                        <strong>Skipped:</strong> {{ log.skipReason }}
                      </small>
}
                      @if (!log.errorMessage && !log.skipReason) {
<span>-</span>
}
                    </td>
                    <td>
                      @if (log.aiResponseJson) {
<button
                       
                        type="button"
                        class="btn btn-sm btn-info no-arrow"
                        (click)="viewJsonDialog(log)"
                        title="View AI Response JSON">
                        <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle; margin-right: 4px;">visibility</mat-icon>
                        View
                      </button>
}
                      @if (!log.aiResponseJson) {
<span class="text-muted">-</span>
}
                    </td>
                  </tr>
}
                </tbody>
              </table>
}
            </div>

            <!-- Mat-Paginator -->
            @if (jobLogsTotal > 0) {
<mat-paginator 
             
              [length]="jobLogsTotal" 
              [pageSize]="jobLogsPageSize" 
              [pageIndex]="jobLogsPageNumber - 1"
              [pageSizeOptions]="[10, 25, 50, 100]" 
              (page)="onPageChange($event)" 
              [showFirstLastButtons]="true">
            </mat-paginator>
}
          </div>
        </div>
}
      </div>
    </div>
  </section>
</main>
